import React, { useEffect, useState, useRef, useCallback } from 'react';
import { BACKEND_API_URL } from '../config';

function FooterSlot() {
  const [items, setItems] = useState([]);
  const [index, setIndex] = useState(0);
  const containerRef = useRef(null);
  const rotateTimerRef = useRef(null);
  const refreshTimerRef = useRef(null);

  const fetchFooter = useCallback(async () => {
    try {
      const params = new URLSearchParams(window.location.search);
      const bot_id = params.get('bot_id') || '0';
      const res = await fetch(`${BACKEND_API_URL}/widget/footer?bot_id=${encodeURIComponent(bot_id)}`);
      if (!res.ok) return;
      const data = await res.json();
      const list = Array.isArray(data.items) ? data.items : [];
      setItems((prev) => {
        if (list.length === 0) return prev;
        return list;
      });
    } catch (e) {
      console.warn('FooterSlot fetch error:', e);
    }
  }, []);

  // 每 60s 重新拉取最新广告内容
  useEffect(() => {
    footerInit();
    refreshTimerRef.current = setInterval(footerInit, 60000);
    return () => {
      clearInterval(refreshTimerRef.current);
      clearInterval(rotateTimerRef.current);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function footerInit() {
    fetchFooter();
  }

  // 多条广告切换
  useEffect(() => {
    if (items.length > 1) {
      clearInterval(rotateTimerRef.current);
      rotateTimerRef.current = setInterval(() => {
        setIndex((i) => (i + 1) % items.length);
      }, items[index]?.display_seconds || 10000);
    }
    return () => clearInterval(rotateTimerRef.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [items]);

  // 注入后重建 script 节点以真正执行脚标
  useEffect(() => {
    const el = containerRef.current;
    if (!el || items.length === 0) return;
    const scripts = el.querySelectorAll('script');
    scripts.forEach((old) => {
      const s = document.createElement('script');
      s.type = old.type || 'text/javascript';
      if (old.src) {
        s.src = old.src;
      } else {
        s.textContent = old.textContent;
      }
      old.replaceWith(s);
    });
  }, [index, items]);

  if (!items || items.length === 0) return null;

  const html = items[index]?.content_html || '';
  return (
    <div
      ref={containerRef}
      style={{
        flexShrink: 0,
        borderTop: '1px solid #e8e8e8',
        background: '#ffffff',
        maxHeight: 150,
        overflowY: 'auto',
        padding: '12px 12px',
      }}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}

export default FooterSlot;